import { ContestManagement, ContestManagementDisc, LiveSessionStatus } from "./generated/core-types";
import { contestOngoing as contestOngoingFn } from "./core";

export type ServerStatusEnum = "FETCHING" | "LIVE" | "NO_LIVE";
export const NoContest: ContestManagement = { type: ContestManagementDisc.NoContest };
export interface ServerStatus {
  status: ServerStatusEnum;
  text: string;
  contest: ContestManagement;
  logs: string[];
  connection: LiveSessionStatus | null;
  transport: "connecting" | "connected" | "disconnected";
  requestPending: boolean;
  requestError: string | null;
}
export const initialServerStatus: ServerStatus = {
  status: "FETCHING", text: "Đang kiểm tra trạng thái máy chủ", contest: NoContest, logs: [],
  connection: null, transport: "connecting", requestPending: false, requestError: null,
};
export const connectionActive = (s: ServerStatus): boolean =>
  s.status !== "FETCHING" && !s.requestPending && s.transport === "connected";
export const contestOngoing = (s: ServerStatus): boolean => contestOngoingFn(s.contest);
export const connectionStateText = (state: string): string => ({
  STARTING: "Đang khởi động",
  CONNECTED: "Đã kết nối",
  RECONNECTING: "Đang kết nối lại",
  DISCONNECTED: "Đã ngắt kết nối",
  INTERRUPTED: "Bị gián đoạn",
  STOPPED: "Đã dừng",
  ERROR: "Có lỗi",
}[state] ?? state);
export const transportStateText = (state: ServerStatus["transport"]): string => ({
  connecting: "Đang kết nối",
  connected: "Đã kết nối",
  disconnected: "Đã ngắt kết nối",
}[state]);
export const addLog = (s: ServerStatus, text: string): ServerStatus => ({
  ...s, logs: [...s.logs.slice(-199), new Date().toLocaleTimeString("en-GB") + ": " + text],
});
export const applySessionStatus = (s: ServerStatus, connection: LiveSessionStatus): ServerStatus => {
  const active = ["STARTING", "CONNECTED", "RECONNECTING", "DISCONNECTED"].includes(connection.state);
  const changed = s.connection?.sessionId !== connection.sessionId || s.connection?.state !== connection.state;
  const next: ServerStatus = { ...s, connection, status: active ? "LIVE" : "NO_LIVE",
    text: connection.error ?? connectionStateText(connection.state),
    contest: s.connection?.sessionId === connection.sessionId ? s.contest : NoContest };
  return changed ? addLog(next, "Facebook: " + connectionStateText(connection.state) + (connection.error ? " (" + connection.error + ")" : "")) : next;
};
export const contestStarted = (s: ServerStatus, contest: ContestManagement): ServerStatus => ({ ...s, contest });
